import { Component, HostBinding } from '@angular/core';
import { BaseRequest } from 'src/app/models/requests/baseRequest';
import { DataService } from 'src/app/shared/services/data.service';
import { IconService } from 'src/app/shared/services/icon.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-registration-page',
  templateUrl: './registration-page.component.html',
})
export class RegistrationPageComponent {
  @HostBinding('class') get pageClasses() {
    return {
      'w-100': true,
      'd-flex': true,
      'flex-column-mobile': true
    }
  };
  portalRegistrationPageData:any;
  isLoading: boolean = true;
  constructor(private dataService:DataService,private iconService: IconService) { }
  
  ngOnInit() {
    this.getData(environment.apiUrl + '/Portal/Login/Index');
  }

  getData(url: string) {
    this.isLoading = true;
    var request:BaseRequest={
      cultureCode:this.dataService.getCultureCode()
    }
    this.dataService.getPortalRegistrationPageData(url,request).subscribe({
      next: (data) => 
      {
        data = JSON.parse(data)
        this.portalRegistrationPageData = data;
        if(data.pageTitle)
          document.title = data.pageTitle;
        this.iconService.addIconToRegistry({
          key:this.portalRegistrationPageData.icon.name,
          path:this.portalRegistrationPageData.icon?.content?.umbracoFile ? this.portalRegistrationPageData.icon.content.umbracoFile : ""
        })
        this.isLoading = false;
      },
      error: (e) => console.error(e)
    });

    // setTimeout(() => {
    //   let url2 = environment.apiUrl + '/Portal/Login/TestLoginMethod';
    //   var request2:BaseRequest={
    //     cultureCode:this.dataService.getCultureCode()
    //   }
    //   this.dataService.getDataByToken(url2, request2).subscribe({
    //     next: (data) => 
    //     {
    //       console.log(data);
    //     },
    //     error: (e) => console.error(e)
    //   });
    // }, 3000);
   }
}
